import { useContext } from "react";
import { Button } from "primereact/button";
import { VideoContext } from "../VideoContext";

const ActionPane = ({ hasExercise }: { hasExercise: boolean }) => {
  const {
    inLessonMode,
    inQuizMode,
    inExerciseMode,
    quiz,
    onQuizTake,
    onQuizReview,
    onLessonClick,
    onExerciseLaunch,
    isExercisePassed,
  } = useContext(VideoContext);

  const isQuizComplete = quiz.assessment?.answersCount === quiz.assessment?.questionsCount;

  return (
    <div className="flex flex-col gap-4 w-full">
      {(inQuizMode || inExerciseMode) && (
        <Button
          severity="secondary"
          label="Watch or read the lesson"
          data-testid="video-lesson-watch-button"
          onClick={onLessonClick}
        />
      )}
      {inLessonMode &&
        (isQuizComplete ? (
          <Button
            link
            label="Review quiz results"
            data-testid="video-lesson-review-quiz-button"
            onClick={onQuizReview}
          />
        ) : (
          <Button
            label="Take the quiz"
            data-testid="video-lesson-take-quiz-button"
            onClick={onQuizTake}
          />
        ))}
      {inLessonMode &&
        hasExercise &&
        (isExercisePassed ? (
          <Button
            link
            label="Launch the exercise"
            data-testid="video-lesson-launch-exercise-button"
            onClick={onExerciseLaunch}
          />
        ) : (
          <Button
            label="Pass the exercise"
            data-testid="video-lesson-launch-exercise-button"
            onClick={onExerciseLaunch}
          />
        ))}
    </div>
  );
};

export default ActionPane;
